import { render, staticRenderFns } from "./ObjectGalleryList.vue?vue&type=template&id=7954d904&scoped=true&"
import script from "./ObjectGalleryList.vue?vue&type=script&lang=js&"
export * from "./ObjectGalleryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7954d904",
  null
  
)

export default component.exports